import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { ClientesService } from 'src/app/services/clientes.service';
import { GruposService } from 'src/app/services/grupos.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-hoja-entrega',
  templateUrl: './hoja-entrega.component.html',
  styleUrls: ['./hoja-entrega.component.scss']
})
export class HojaEntregaComponent implements OnInit {
  environment = environment.BASE_URL

  grupoid:any;
  data:any;
  respuestaGet:any;
  respuestGrupos:any;
  alumnos:any;
  
  datosGrupo:any;
  respuestaPagos:any;

  pagos:any;
  total = 0;
  totalCliente = 0;
  saldo = 0;
  por_cobrar = 0;
  pagado = 0;
  usuarioid:any;
  datos_grupo:any;

  formulario:any;
  fechaPago:any;
  formularioPago:any;
  respuestaAgregarPagos:any;
  indicadores:any;

  observaciones:any = [];
  recibe:any = [];


  constructor(private actRoute:ActivatedRoute, private _getDetalleGrupo: GruposService, private _cliente:ClientesService,
    private modalService:NgbModal,
    private iziToast:Ng2IzitoastService) { }

  ngOnInit(): void {
    this.actRoute.paramMap.subscribe(params => {
      this.grupoid = this.actRoute.snapshot.paramMap.get('grupo');
      if (this.grupoid){
        this.getHojaEntregaGrupo(this.grupoid);
        this.getDatosGrupo(this.grupoid);
      }
      
    });

    this.datosGrupo = {
      'escuela':'',
      'carrera':'',
      'grupo':'',
    }

    this.formulario = {
      monto: '',
      usuarioid: '',
      fecha: '',
    }

    this.formularioPago = {
      tipo_pago: '',
      folio: '',
    }

  }

  getHojaEntregaGrupo(grupoid){
    this.data = {
      'grupo': grupoid,
    }

    this._getDetalleGrupo.getHojaEntregaGrupo(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.alumnos = this.respuestaGet.content;
          this.indicadores = this.respuestaGet.indicadores;
          this.por_cobrar = this.indicadores.por_cobrar;
          this.pagado = this.indicadores.pagado;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getDatosGrupo(grupoid){
    this.data = {
      'grupo': grupoid,
    }

    this._getDetalleGrupo.getDatosGrupo(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosGrupo = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  entregarPaquete(alumnoId, indice){
    this.data = {
      'estatus':3,
      'usuario':alumnoId,
      'observaciones': this.observaciones[indice],
      'recibio': this.recibe[indice],
    }

    this._cliente.entregarPaquete(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getHojaEntregaGrupo(this.grupoid);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPagos(idusuario){
    this.data = {
      'usuario':idusuario
    }
    this._cliente.getPagos(this.data).subscribe(
      data => {
        this.respuestaPagos = data;
        if(this.respuestaPagos.success){
          this.pagos = this.respuestaPagos.content;
          this.total = this.respuestaPagos.total;
          this.totalCliente = this.respuestaPagos.compraMonto;
          this.saldo = this.respuestaPagos.saldo;
          this.usuarioid = this.respuestaPagos.usuarioid;
          this.datos_grupo = this.respuestaPagos.datos_pagos;
          document.getElementById('click').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }


  agregarPago(dataid, forma_pago){

    if (this.formulario.fecha != null){
      this.fechaPago = this.formulario.fecha['year']+'-'+this.formulario.fecha['month']+'-'+this.formulario.fecha['day']
    }
    this.data = {
      'pago': this.formulario.monto,
      'folio': this.formulario.folio,
      'forma_pago':forma_pago,
      'usuario': dataid,
      'tipo_pago':this.formularioPago.tipo_pago,
      'fecha':this.fechaPago,
    }
    
    this._cliente.agregarPago(this.data).subscribe(
      data => {
        this.respuestaAgregarPagos = data;
        if(this.respuestaPagos.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado el pago correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.formulario.folio = '';
          this.dismissAll();
          this.getHojaEntregaGrupo(this.grupoid);
          this.getPagos(this.usuarioid);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }


  cerrarGrupo(grupo){
    this.data = {
      'grupo': grupo
    }
    this._getDetalleGrupo.cerrarGrupo(this.data).subscribe(
      data => {
        this.respuestGrupos = data;
        if(this.respuestGrupos.success){
          this.iziToast.show(
            {
                title: 'Se ha cerrado el grupo correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });

            setTimeout(function() {  window.location.href='grupos'; }, 5000);
         
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
    
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
